<template>
  <base-page>
    <el-card style="margin: 5px 0px 5px 0px">
      <el-collapse accordion style="border: none">
        <el-collapse-item name="1" style="border: none">
          <template slot="title">
            <div slot="header" class="clearfix">
              <titlu-pagina Titlu="Raport analiza" @on_add_clicked="show_dialog()" :AdaugaVisible="false" />
            </div>
          </template>
          <div class="filtre">
            <el-form @submit.prevent="refresh_info()">
              <el-row style="margin: 10px" class="input-group">
                <el-col class="input-element">
                  <el-form-item label="Numar inmatriculare" size="mini">
                    <el-input v-model="Filters.Numar" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Marca" size="mini">
                    <el-select v-model="Filters.Marca" @change="marcaChangeHandler()" class="full-width" filterable
                      size="mini" clearable>
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.marci" :key="'marci' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Model" size="mini">
                    <el-select v-model="Filters.Model" @change="refresh_info" class="full-width" filterable size="mini"
                      clearable :disabled="Filters.Marca == -1 || Filters.Marca == '' || !Filters.Marca">
                      <el-option label="Toate" value="-1" />
                      <el-option v-for="item in Info.modele" :key="'modele' + item.Id" :label="item.Nume"
                        :value="item.Id"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Tip auto" size="mini">
                    <el-select v-model="Filters.TipAuto" class="full-width">
                      <el-option label="Toate" value="-1"></el-option>
                      <el-option label="Normal" value="Normal"></el-option>
                      <el-option label="SUV" value="SUV"></el-option>
                      <el-option label="Autoutilitar" value="Autoutilitar"></el-option>
                      <el-option label="Supercar" value="Supercar"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Nume client" size="mini">
                    <el-input v-model="Filters.Client" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Numar deviz" size="mini">
                    <el-input v-model="Filters.Id" clearable />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Mecanic' size="mini">
                    <div class="input-group full-width">
                      <el-select class='full-width' v-model='Filters.IdMecanic' filterable>
                        <el-option label='Toti' value='-1'></el-option>
                        <el-option-group key="Activi">
                          <el-option v-for='item in Info.mecanici' :key="'mecanici' + item.Id" :label='item.Nume'
                            :value='item.Id' />
                        </el-option-group>
                        <el-option-group v-if="Filters.ArataMecaniciInactivi == 1" key="Inactivi" label="Inactivi">
                          <el-option v-for='item in Info.mecanici_inactivi' :key="'mecanici_inactivi' + item.Id"
                            :label='item.Nume' :value='item.Id' />
                        </el-option-group>
                        <el-option-group v-if="Filters.ArataMecaniciStersi == 1" key="Stersi" label="Stersi">
                          <el-option v-for='item in Info.mecanici_stersi' :key="'mecanici_stersi' + item.Id"
                            :label='item.Nume' :value='item.Id' />
                        </el-option-group>
                      </el-select>
                      <div class="input-group-append">
                        <el-checkbox size="mini" v-model="Filters.ArataMecaniciInactivi" true-label="1" false-label="0"
                          @change="schimbaListaMecanici()">
                          <small>Arata inactivi</small>
                        </el-checkbox>
                        <el-checkbox size="mini" v-model="Filters.ArataMecaniciStersi" true-label="1" false-label="0"
                          @change="schimbaListaMecaniciStersi()">
                          <small>Arata stersi</small>
                        </el-checkbox>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Centru productie' size="mini">
                    <el-select class='full-width' v-model='Filters.IdCentruProductie' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.centre_productie' :key="'centre_productie' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Serviciu programator' size="mini">
                    <el-select class='full-width' v-model='Filters.IdServiciuProgramator' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option v-for='item in Info.servicii_programator' :key="'serviciu_programator' + item.Id"
                        :label='item.Nume' :value='item.Id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Status' size="mini">
                    <el-select class='full-width' v-model='Filters.Status' filterable>
                      <el-option label='Aprobate' value='Aprobat'></el-option>
                      <el-option label='Draft' value='Draft'></el-option>
                      <el-option label='In validare' value='In_validare'></el-option>
                      <el-option label='Facturate' value='Facturat'></el-option>
                      <el-option label='Toate' value='-1'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Tip anvelope' size="mini">
                    <el-select class='full-width' v-model='Filters.TipAnvelope' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option label='Hotel' value='Hotel'></el-option>
                      <el-option label='Noi' value='Noi'></el-option>
                      <el-option label='Vechi' value='Vechi'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Valoare Min" size="mini">
                    <el-input-number v-model="Filters.ValoareMin" :precision="0" :max="999999" :min="0" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label="Valoare Max" size="mini">
                    <el-input-number v-model="Filters.ValoareMax" :precision="0" :max="999999" :min="0" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Hotel' size="mini">
                    <el-select class='full-width' v-model='Filters.Hotel' filterable>
                      <el-option label='Toate' value='-1'></el-option>
                      <el-option label='Da' value='1'></el-option>
                      <el-option label='Nu' value='0'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label='Agent' size="mini">
                    <el-select class='full-width' v-model='Filters.NumeAgent' filterable>
                      <el-option label='Toti' value='-1'></el-option>
                      <el-option v-for='item in Info.agenti' :key="'agenti' + item.NumeAgent" :label='item.NumeAgent'
                        :value='item.NumeAgent' />
                    </el-select>
                  </el-form-item>
                </el-col>


                <!-- <el-col class="input-element"></el-col> -->

                <el-col class="input-element">
                  <el-form-item label='Interval semnare fisa' size="mini">
                    <el-date-picker class="full-width" v-model="Filters.DataConsimtamant"
                      :picker-options="datePickerOptions" type="datetimerange" range-separator=":"
                      start-placeholder="Start" end-placeholder="Stop" format="dd/MM/yyyy HH:mm"
                      value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Interval start deviz' size="mini">
                    <el-date-picker class="full-width" v-model="Filters.DataStartDeviz"
                      :picker-options="datePickerOptions" type="datetimerange" range-separator=":"
                      start-placeholder="Start" end-placeholder="Stop" format="dd/MM/yyyy HH:mm"
                      value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Interval stop deviz' size="mini">
                    <el-date-picker class="full-width" v-model="Filters.DataEndDeviz"
                      :picker-options="datePickerOptions" type="datetimerange" range-separator=":"
                      start-placeholder="Start" end-placeholder="Stop" format="dd/MM/yyyy HH:mm"
                      value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" />
                  </el-form-item>
                </el-col>
                <el-col class="input-element">
                  <el-form-item label='Interval facturare' size="mini">
                    <el-date-picker class="full-width" v-model="Filters.DataFacturare"
                      :picker-options="datePickerOptions" type="datetimerange" range-separator=":"
                      start-placeholder="Start" end-placeholder="Stop" format="dd/MM/yyyy HH:mm"
                      value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']" />
                  </el-form-item>
                </el-col>

                <el-col class="input-element"></el-col>

                <el-col class="input-element">
                  <el-form-item label="Durata Start-End (sec)" size="mini" style="margin-bottom: 1px !important;">
                    <el-tooltip placement="bottom-end" effect="light">
                      <div slot="content">Intervalul in secunde dintre data preluarii devizului in lucru de catre
                        mecanic si data
                        inchiderii devizului de catre mecanic.</div>
                      <i class="el-icon-info" style="font-size: 15px;color:#409EFF"></i>
                    </el-tooltip>
                    <el-input-number v-model="Filters.DurataStartEndMin" :precision="0" :max="999999" :min="0"
                      placeholder="min" />
                  </el-form-item>
                  <el-form-item size="mini">
                    <el-input-number v-model="Filters.DurataStartEndMax" :precision="0" :max="999999" :min="0"
                      placeholder="max" />
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label="Durata Fisa-End (sec)" size="mini" style="margin-bottom: 1px !important;">
                    <el-tooltip placement="bottom-end" effect="light">
                      <div slot="content">Intervalul in secunde dintre data semnarii consimtamantului si data inchiderii
                        devizului
                        de catre mecanic.</div>
                      <i class="el-icon-info" style="font-size: 15px;color:#409EFF"></i>
                    </el-tooltip>
                    <el-input-number v-model="Filters.DurataFisaEndMin" :precision="0" :max="999999" :min="0"
                      placeholder="min" />
                  </el-form-item>
                  <el-form-item size="mini">
                    <el-input-number v-model="Filters.DurataFisaEndMax" :precision="0" :max="999999" :min="0"
                      placeholder="max" />
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label="Durata Fisa-Fact (sec)" size="mini" style="margin-bottom: 1px !important;">
                    <el-tooltip placement="bottom-end" effect="light">
                      <div slot="content">Intervalul in secunde dintre data semnarii consimtamantului si data emiterii
                        facturii.
                      </div>
                      <i class="el-icon-info" style="font-size: 15px;color:#409EFF"></i>
                    </el-tooltip>
                    <el-input-number v-model="Filters.DurataFisaFacturareMin" :precision="0" :max="999999" :min="0"
                      placeholder="min" />
                  </el-form-item>
                  <el-form-item size="mini">
                    <el-input-number v-model="Filters.DurataFisaFacturareMax" :precision="0" :max="999999" :min="0"
                      placeholder="max" />
                  </el-form-item>
                </el-col>

                <el-col class="input-element">
                  <el-form-item label="Durata End-Fact (sec)" size="mini" style="margin-bottom: 1px !important;">
                    <el-tooltip placement="bottom-end" effect="light">
                      <div slot="content">Intervalul in secunde dintre data inchiderii devizului de catre mecanic si
                        data emiterii
                        facturii.</div>
                      <i class="el-icon-info" style="font-size: 15px;color:#409EFF"></i>
                    </el-tooltip>
                    <el-input-number v-model="Filters.DurataEndFacturareMin" :precision="0" :max="999999" :min="0"
                      placeholder="min" />
                  </el-form-item>
                  <el-form-item size="mini">
                    <el-input-number v-model="Filters.DurataEndFacturareMax" :precision="0" :max="999999" :min="0"
                      placeholder="max" />
                  </el-form-item>
                </el-col>

                <el-col :md="24">
                  <el-button type="primary" native-type="submit" @click="refresh_info()" size="mini">Aplica</el-button>
                  <el-button type="danger" native-type="submit" @click="reset()" size="mini">Reseteaza</el-button>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
    </el-card>


    <el-table :data="Results">
      <el-table-column type="expand" align="center" width="30px">
        <template #default="props">
          <el-table class="tabel2" style="width: 92%; margin-left: 4%; margin-right: 4%;" border
            :data="props.row.Produse">
            <el-table-column prop="NumeProdus" label="Produs"></el-table-column>
            <el-table-column prop="Cantitate" label="Cantitate" align="right"></el-table-column>
            <el-table-column prop="Pret" label="Pret" align="right"></el-table-column>
            <el-table-column prop="Valoare" label="Valoare" align="right">
              <template slot-scope="scope">
                {{ scope.row.Valoare + " lei" }}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="Id" label="#" width="60px"></el-table-column>
      <el-table-column label="Data programarii">
        <template slot-scope="scope">
          {{ scope.row.DataRezervarii | DataOra }}
        </template>
      </el-table-column>
      <el-table-column label="Data fisa">
        <template slot-scope="scope">
          {{ scope.row.DataDeschiderii | DataOra }}
        </template>
      </el-table-column>
      <el-table-column label="Data Start">
        <template slot-scope="scope">
          {{ scope.row.DataPreluareInLucru | DataOra }}
        </template>
      </el-table-column>
      <el-table-column label="Data End">
        <template slot-scope="scope">
          {{ scope.row.DataTerminareLucru | DataOra }}
        </template>
      </el-table-column>
      <el-table-column label="Data facturare">
        <template slot-scope="scope">
          {{ scope.row.DataFacturare | DataOra }}
        </template>
      </el-table-column>
      <el-table-column prop="Status" label="Status" width="77" />
      <el-table-column prop="NumeMecanic" label="Mecanic" />
      <el-table-column prop="Agent" label="Agent" />
      <el-table-column prop="NumeServiciu" label="Serviciu" />
      <el-table-column label="Client">
        <template slot-scope="scope">
          <el-tooltip>
            <template #content> <strong> {{ scope.row.NumeClient }} {{ scope.row.PrenumeClient }} </strong>
              <br />Telefon: {{ scope.row.TelefonClient }}
              <br />Email: {{ scope.row.EmailClient }}
            </template>
            <span> {{ scope.row.NumeClient + " " + scope.row.PrenumeClient }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="Numar">
        <template slot-scope="scope">
          <el-tooltip>
            <template #content> <strong> {{ scope.row.Numar }} </strong>
              <br />Marca: {{ scope.row.Marca }}
              <br />Model: {{ scope.row.Model }}
              <br />An: {{ scope.row.An }}
              <br />Km: {{ scope.row.Km }}
            </template>
            <span>{{ scope.row.Numar }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="TipAuto" label="Tip auto" width="80" />
      <el-table-column label="Hotel" width="62">
        <template slot-scope="scope">
          <span v-if="scope.row.Hotel == 1">Da</span>
          <span v-else>Nu</span>
        </template>
      </el-table-column>
      <el-table-column prop="TipAnvelope" label="Tip anvelope" />
      <el-table-column prop="Antifurt" label="Antifurt" width="77">
        <template slot-scope="scope">
          {{ scope.row.Antifurt == 0 ? "Nu" : "Da" }}
        </template>
      </el-table-column>

      <el-table-column label="Durata Start-End" width="77">
        <template slot-scope="scope">
          {{ scope.row.DurataStartEnd | formatSecundeMinuteOre }}
        </template>
      </el-table-column>
      <el-table-column label="Durata Fisa-End" width="77">
        <template slot-scope="scope">
          {{ scope.row.DurataFisaEnd | formatSecundeMinuteOre }}
        </template>
      </el-table-column>
      <el-table-column label="Durata Fisa-Fact" width="77">
        <template slot-scope="scope">
          {{ scope.row.DurataFisaFacturare | formatSecundeMinuteOre }}
        </template>
      </el-table-column>
      <el-table-column label="Durata End-Fact" width="77">
        <template slot-scope="scope">
          {{ scope.row.DurataEndFacturare | formatSecundeMinuteOre }}
        </template>
      </el-table-column>


      <el-table-column prop="ValoareDeviz" label="Valoare">
        <template slot-scope="scope">
          {{ scope.row.ValoareDeviz + " lei" }}
        </template>
      </el-table-column>
    </el-table>

    <div class="total">
      <div v-if='TotalDevizeRaport'>
        <div>Total: <strong>{{ TotalDevizeRaport }} devize</strong></div>
        <!-- <p >Total: <strong>{{TotalDevizeRaport}} devize</strong></p> -->
        <!-- <table >
          <tr v-for="(serv, i) in GrupateServiciu" :key="i" style="font-size: smaller;">
                <td >{{serv.Count}} deviz(e) {{serv.Nume}} </td>
          </tr>
        </table> -->
        <table>
          <tr v-for="(serv, i) in GrupateServiciuCantitate" :key="i" style="font-size: smaller;">
            <div style="padding-left:2em;"><b>{{ serv['Total'] }}</b> deviz(e) <b>{{ i }}</b> din care:</div>
            <div v-for="(serv2, y) in serv['Grupate']" :key="y" style="padding-left:3em; ">{{ serv2 }} deviz(e) -
              Cantitate:
              {{ y }} bucati</div>
          </tr>
        </table>
        <br />
      </div>
      <p v-if="ValoareDevize">Total valoare: <strong>{{ ValoareDevize | format_money }} lei</strong></p>

      <p v-if="DurataTotalaDevizeRaport">Total durata Start-End: <strong>{{ DurataTotalaDevizeRaport }} secunde<span
            v-if="DurataTotalaDevizeRaport > 120"> ({{ DurataTotalaDevizeRaport |
              formatSecundeMinuteOre }})</span></strong>
      </p>

      <p v-if="DurataStartEndMedieDevizeRaport">Durata medie Start-End (pe deviz):
        <strong>{{ DurataStartEndMedieDevizeRaport }} secunde<span v-if="DurataStartEndMedieDevizeRaport > 120">
            ({{ DurataStartEndMedieDevizeRaport | formatSecundeMinuteOre }})</span></strong>
      </p>
      <p v-if="DurataFisaEndMedieDevizeRaport">Durata medie Fisa-End (pe deviz):
        <strong>{{ DurataFisaEndMedieDevizeRaport }}
          secunde<span v-if="DurataFisaEndMedieDevizeRaport > 120"> ({{ DurataFisaEndMedieDevizeRaport |
            formatSecundeMinuteOre }})</span></strong>
      </p>
      <p v-if="DurataFisaFacturareMedieDevizeRaport">Durata medie Fisa-Fact (pe deviz):
        <strong>{{ DurataFisaFacturareMedieDevizeRaport }} secunde<span
            v-if="DurataFisaFacturareMedieDevizeRaport > 120">
            ({{ DurataFisaFacturareMedieDevizeRaport | formatSecundeMinuteOre }})</span></strong>
      </p>
      <p v-if="DurataEndFacturareMedieDevizeRaport">Durata medie End-Fact (pe deviz):
        <strong>{{ DurataEndFacturareMedieDevizeRaport }} secunde<span v-if="DurataEndFacturareMedieDevizeRaport > 120">
            ({{ DurataEndFacturareMedieDevizeRaport | formatSecundeMinuteOre }})</span></strong>
      </p>

      <!-- <p v-if="DurataFisaEndMedieDevizeRaport">Durata medie Fisa-End   (pe deviz): <strong>{{DurataFisaEndMedieDevizeRaport}} secunde<span v-if="DurataFisaEndMedieDevizeRaport > 120" > ( aprox {{(DurataFisaEndMedieDevizeRaport/60).toFixed(2)}} minute)</span></strong></p>
      <p v-if="DurataFisaFacturareMedieDevizeRaport">Durata medie Fisa-Fact  (pe deviz): <strong>{{DurataFisaFacturareMedieDevizeRaport}} secunde<span v-if="DurataFisaFacturareMedieDevizeRaport > 120" > ( aprox {{(DurataFisaFacturareMedieDevizeRaport/60).toFixed(0)}} minute)</span></strong></p>
      <p v-if="DurataEndFacturareMedieDevizeRaport">Durata medie End-Fact   (pe deviz): <strong>{{DurataEndFacturareMedieDevizeRaport}} secunde<span v-if="DurataEndFacturareMedieDevizeRaport > 120" > ( aprox {{(DurataEndFacturareMedieDevizeRaport/60).toFixed(0)}} minute)</span></strong></p> -->
    </div>

    <el-pagination @size-change="refresh_info" @current-change="refresh_info" :page-size.sync="PaginationInfo.PerPage"
      :current-page.sync="PaginationInfo.Page" :total="PaginationInfo.RowCount" layout="pager" />
  </base-page>
</template>

<script>
import settings from "@/backend/LocalSettings";
import BasePage from "@/pages/Admin/BasePage";
import TitluPagina from "@/widgets/TitluPagina";
import moment from 'moment';

export default {
  name: "masini",
  extends: BasePage,
  components: {
    "base-page": BasePage,
    "titlu-pagina": TitluPagina,
  },
  data() {
    return {
      datePickerOptions: settings.datePickerOptions,
      ValoareDevize: "",
      DurataTotalaDevizeRaport: "",
      TotalDevizeRaport: "",
      GrupateServiciu: [],
      GrupateServiciuCantitate: [],

      DurataStartEndMedieDevizeRaport: "",
      DurataFisaEndMedieDevizeRaport: "",
      DurataFisaFacturareMedieDevizeRaport: "",
      DurataEndFacturareMedieDevizeRaport: "",

      device: "",
      Results: [],
      DateList: [],
      base_url: "",
      Info: {
        centre_productie: [],
        servicii_programator: [],
        marci: [],
        modele: [],
      },
      Filters: {
        DataConsimtamant: [moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'), moment().format('YYYY-MM-DD HH:mm:ss')],
        DataStartDeviz: [],
        DataEndDeviz: [],
        DataFacturare: [],
        Numar: "",
        DataDeschiderii: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        IdMecanic: "-1",
        Status: "Facturat",
        TipAnvelope: "-1",
        Id: "",
        ValoareMin: "",
        ValoareMax: "",
        DurataStartEndMin: "",
        DurataStartEndMax: "",
        DurataFisaEndMin: "",
        DurataFisaEndMax: "",
        DurataFisaFacturareMin: "",
        DurataFisaFacturareMax: "",
        DurataEndFacturareMin: "",
        DurataEndFacturareMax: "",
        Client: "",
        Model: "-1",
        Marca: "-1",
        TipAuto: "-1",
        Hotel: "-1",
        ArataMecaniciInactivi: "0",
        ArataMecaniciStersi: '0',
        NumeAgent: "-1",
      },
      OrderBy: {},
      PaginationInfo: {
        Page: 1,
        PerPage: 50,
        RowCount: 0,
        PageSizes: [10, 25, 50, 100, 200],
      },
    };
  },
  methods: {
    async preview(id) {
      this.$refs.preview_deviz.show(id)
    },

    format_zi(data) {
      return moment(data).format('YYYY-MM-DD')
    },

    schimbaListaMecanici() {
      if (this.Filters.ArataMecaniciInactivi == 0) {
        let MecaniculSelectat = this.Info.mecanici_inactivi.filter((value) => value.Id == this.Filters.IdMecanic);
        if (MecaniculSelectat.length > 0)
          if (MecaniculSelectat[0].Dezactivat == 1) this.Filters.IdMecanic = "-1";
      }
    },
    schimbaListaMecaniciStersi() {
      if (this.Filters.ArataMecaniciStersi == 0) {
        let mecanicSelectat = this.Info.mecanici_stersi.filter((value) => value.Id == this.Filters.IdMecanic);
        if (mecanicSelectat.length > 0) {
          if (mecanicSelectat[0].Sters == 1) {
            this.Filters.IdMecanic = "-1";
          }
        }
      }
    },

    calculeaza_durata(start, stop) {
      return moment(stop).diff(start, 'minutes');
    },

    async marcaChangeHandler() {
      if (!this.Filters.Marca || this.Filters.Marca == '-1') {
        this.Info.modele = [];
        this.Filters.Model = '-1';
      }
      if (this.Filters.Marca) {
        const response = await this.post("receptie/devize/get_model_for_marca", { id_marca: this.Filters.Marca });
        if (response && response.modele) {
          this.Info.modele = response.modele;
        } else {
          this.Info.modele = [];
          this.Filters.Model = '';
        }
      }

      await this.refresh_info();
    },

    format_ora(data) {
      return moment(data).format('HH:mm:ss')
    },

    print_inspectie(id_deviz) {
      let isDev = '';
      if (this.base_url == 'https://service.anvelopeinstoc.ro/dev/api/index.php') {
        isDev = '/dev'
      }
      window.open(isDev + "/#/inspectie_finala/" + id_deviz, '_blank');
    },

    print_deviz(id_deviz) {
      let isDev = '';
      if (this.base_url == 'https://service.anvelopeinstoc.ro/dev/api/index.php') {
        isDev = '/dev'
      }
      window.open(isDev + "/#/deviz_produse_pdf/" + id_deviz, '_blank');
    },

    async get_info() {
      var response = await this.post("receptie/devize/get_info_raport_mecanici");
      this.Info.agenti = response.agenti;
      this.Info.mecanici = response.mecanici;
      this.Info.mecanici_inactivi = response.mecanici_inactivi;
      this.Info.mecanici_stersi = response.mecanici_stersi;
      this.Info.centre_productie = response.centre_productie;
      this.Info.servicii_programator = response.servicii_programator;
      this.Info.marci = response.marci;
      this.refresh_info();
    },

    async refresh_info() {
      var response = await this.post("receptie/devize/get_raport_analiza_grupat", {
        Filters: this.Filters,
        OrderBy: this.OrderBy,
        PaginationInfo: this.PaginationInfo,
      });
      this.Results = response.Results;
      this.PaginationInfo = response.PaginationInfo;

      this.TotalDevizeRaport = 0;
      this.GrupateServiciu = [];
      this.GrupateServiciuCantitate = [];

      this.DurataStartEndMedieDevizeRaport = 0;
      this.DurataFisaEndMedieDevizeRaport = 0;
      this.DurataFisaFacturareMedieDevizeRaport = 0;
      this.DurataEndFacturareMedieDevizeRaport = 0;

      this.DurataTotalaDevizeRaport = 0;
      this.ValoareDevize = 0;
      if (response.Totaluri !== undefined) {
        this.TotalDevizeRaport = response.Totaluri.TotalDevizeRaport;

        this.DurataStartEndMedieDevizeRaport = response.Totaluri.DurataStartEndMedieDevizeRaport;
        this.DurataFisaEndMedieDevizeRaport = response.Totaluri.DurataFisaEndMedieDevizeRaport;
        this.DurataFisaFacturareMedieDevizeRaport = response.Totaluri.DurataFisaFacturareMedieDevizeRaport;
        this.DurataEndFacturareMedieDevizeRaport = response.Totaluri.DurataEndFacturareMedieDevizeRaport;

        this.DurataTotalaDevizeRaport = response.Totaluri.DurataTotalaDevizeRaport;
        this.ValoareDevize = response.Totaluri.ValoareDevize;
      }
      if (response.GrupateServiciu !== undefined) {
        this.GrupateServiciu = response.GrupateServiciu;
      }
      if (response.GrupateServiciuCantitate !== undefined) {
        this.GrupateServiciuCantitate = response.GrupateServiciuCantitate;
      }


    },
    reset() {
      this.Filters = {
        DataConsimtamant: [moment().startOf('month').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
        DataStartDeviz: [],
        DataEndDeviz: [],
        DataFacturare: [],
        Numar: "",
        TipAuto: "-1",
        DataDeschiderii: "",
        IdCentruProductie: "-1",
        IdServiciuProgramator: "-1",
        IdMecanic: "-1",
        Status: "Facturat",
        TipAnvelope: "-1",
        Id: "",
        ValoareMin: "",
        ValoareMax: "",
        DurataStartEndMin: "",
        DurataStartEndMax: "",
        DurataFisaEndMin: "",
        DurataFisaEndMax: "",
        DurataFisaFacturareMin: "",
        DurataFisaFacturareMax: "",
        DurataEndFacturareMin: "",
        DurataEndFacturareMax: "",
        Client: "",
        Model: "-1",
        Marca: "-1",
        TipAuto: "-1",
        Hotel: "-1",
        NumeAgent: "-1",
        ArataMecaniciInactivi: '0',
        ArataMecaniciStersi: '0',
      };
      this.refresh_info();
    },

  },

  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.device = "phone"
    } else this.device = "computer"
  },
  mounted() {
    this.select_menu_item("raport_analiza");

    // if (!this.$has_right("Management")) {
    //   this.$router.push("/no-rights");
    //   return;
    // }
    this.base_url = settings.BASE_URL;
    this.get_info();
  },
};
</script>

<style lang="less" scoped>
.top50 {
  margin-top: 20px;
}

.input-group {
  display: flex;
  align-items: flex-start;
  // justify-content: space-between;
}

.filtre {
  .el-input-number {
    width: 100% !important;
  }
}

.tabel2 {

  background-color: rgb(71, 70, 71);

}


.total {
  width: 100%;
  background-color: white;
  padding: 14px 10px;
  text-align: start;
  font-size: 18px;
}


.input-element {
  width: 18%;
  margin-right: 2%;
}

.semi-full-width {
  width: 80%;
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 600px) {
  .input-element {
    width: 80%;

  }

  .phone-btn {
    padding-left: 20px;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
  }

  .input-group {
    margin: 10px;
  }

  .el-tooltip__popper {
    width: 90%;
  }

  .el-date-editor--daterange.el-input__inner {
    width: 300px;
  }

  .el-picker-panel__body {
    display: flex;
    flex-direction: column;
  }

}
</style>
